module.exports = __webpack_public_path__ + "img/arrow-circle-right.5777a971.svg";